<div class="modal-body">
  <button type="button" class="close" (click)="activeModal.dismiss()" data-dismiss="modal"><i
      class="icon-close"></i></button>
  <div class="p-5 text-center">
    <div class="px-md-0 update-cart-message">
      <img src="assets/images/frame.png" alt="" class="mx-auto mb-4">
      <h3 class="mb-3 new-question-completed__subtitle">Congratulations, {{firstName}}!</h3>
      <p class="mb-5 new-question-completed__desc">You have
        successfully completed the course on
        <strong>{{courseTitle}}</strong>.</p>
      <a href="javascript:void(0)" (click)="activeModal.dismiss()" class="btn btn-primary my-3"><span>View
          {{isGenerateCompletionCertificate?'Certificate':'Score'}}</span></a>
    </div>
  </div>
</div>
